
import axios from "axios";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { Loader } from "../Loader/Loader";
import AxiosProps from "./AxiosProps";

const AxiosHOC = (props: AxiosProps) => {

    const { children, classes } = props;
    const { show_loader } = useSelector((state: any) => state.main);
    const { token } = useSelector((state: any) => state.auth);

    const setHeaders = useCallback(() => {
        axios.interceptors.request.use(req => {
            if (token) {
                req.headers.authorization = token;
            }
            return req;
        });
    } , [token])

    useEffect(() => {
        setHeaders()
    }, [setHeaders , token])

    return (
        <div className={classes}>
            {children}
            <Loader showLoader={show_loader} />
        </div>
    )
}

export default AxiosHOC;